import React from 'react';
export function StorySection() {
  return <section className="py-14 relative" data-id="element-178">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        

        <div className="prose prose-invert prose-cyan max-w-none text-lg text-gray-300 space-y-6" data-id="element-180">
          <p className="text-2xl font-heading text-white mb-5" data-id="element-181">
            Dear Architect,
          </p>

          <p data-id="element-182">
            I remember the exact moment the office lights stayed off for me.
          </p>

          <p data-id="element-183">
            I was on a Zoom call with my manager, telling him I was leaving. He
            was confused. He looked at my performance metrics—which were higher
            than anyone else's—and then at my resignation letter.
          </p>

          <blockquote className="border-l-2 border-cyan-500 pl-6 py-2 my-8 bg-cyan-500/5 rounded-r-lg italic text-gray-200" data-id="element-184">
            "How?" he asked. "You're making more money working 4 hours a week
            than the firm pays you for 60. Are you just that good at ChatGPT?"
          </blockquote>

          <p data-id="element-185">I told him he was wrong.</p>

          <p data-id="element-186">
            It wasn't about being "good at ChatGPT." It was about treating AI as
            Infrastructure, not a toy.
          </p>

          <p data-id="element-187">
            While my colleagues were manually "prompting" blog posts,
            copying-and-pasting into Google Docs, and chasing clients for $50 an
            article… I was building a{' '}
            <strong className="text-cyan-400 font-bold" data-id="element-188">Ghost Factory</strong>.
          </p>

          <p data-id="element-189">A system designed to scale without me.</p>

          <div className="my-8 p-8 border border-cyan-500/20 bg-dark-900 rounded-lg text-center" data-id="element-190">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-191">
              The "Prompt Engineer" is a Commodity.
            </h3>
            <h3 className="text-3xl font-bold text-cyan-400 text-glow" data-id="element-192">
              The "Architect" is ELITE.
            </h3>
          </div>

          <p data-id="element-193">
            If you are currently trying to make money by selling "AI Writing,"
            you are in a race to the bottom. You are competing against millions
            of overseas freelancers willing to work for $5/hour.
          </p>

          <p data-id="element-194">
            In 2026, the market value of "writing a blog post" has dropped to
            zero.
          </p>

          <p data-id="element-195">Nobody wants to buy prompts anymore. They want to buy OUTCOMES.</p>

          <p data-id="element-196">
            They want their time back. They want a system that identifies leads,
            creates tailored content across 5 platforms, and distributes it
            while the owner sleeps.
          </p>

          <p className="text-xl font-bold text-white mt-8" data-id="element-197">
            That is why I created THE $10K AI CONTENT ENGINE.
          </p>
        </div>
      </div>
    </section>;
}